export default function BMCRadioGroup({ label, children }: any) {
  return (
    <fieldset>
      {/*<legend>{label}</legend>*/}
      {children}
    </fieldset>
  );
}
